import { buildService } from './decorated-service';
import {
  StaticOCRApplication,
  OptionalOCRApplication,
  OCRApplication
} from '../../../core/types/submissions/ocr-application';
import { ocrSubmissionMock } from './ocr-omni-submission-service';
import {
  handleSubmissionError,
  purgeEmptyFields,
  removeExtraAddressFields,
  submissionTimeOutErrorCode
} from './util';
import settings from '../../../settings.json';

const api = buildService(
  '/new-account-svc/service/front-office/account/trac-rollover'
);

export const createOCRTRACApplicationService = async (
  args: OptionalOCRApplication
): Promise<any> => {
  if (settings['mockedMode']) return ocrSubmissionMock;
  const validated: StaticOCRApplication = OCRApplication.check(args);
  const submissionPayload = purgeEmptyFields(validated);
  const finalSubmissionPayload = removeExtraAddressFields(submissionPayload);

  return api.add(finalSubmissionPayload, {
    submissionTimeOutErrorCode,
    handleServiceResponse: handleSubmissionError
  });
};
